module.exports = __webpack_public_path__ + "img/small.4dc2066f.jpg";